export default __webpack_public_path__ + "static/media/Tick Square 2.cab214de.svg";